<style scoped>
.pdd{
  margin: 0 80px;
}
</style>
<template lang="pug">
    form.pdd
      .row
        .col.s12#actions
      .row                                             
        .col.s12.m12.input-field
            h6.txthead Officers
            table
                tr 
                    th Name
                    th Position
                    th Address
                    th Contact
                    th Nationality
                tr( v-if="reseller.officers" v-for="officer in reseller.officers")
                    td {{officer.fullname}}
                    td {{officer.position}}
                    td {{officer.residenceAddress}}
                    td {{officer.contactNo}}
                    td {{officer.nationality}}
            
      .row
        .col.s12.m12.input-field
            h6.txthead Affiliates, Subsidiaries and Branches
            table
                tr 
                    th Business Name
                    th Address
                    th Type of Business
                tr(v-if="reseller.branches" v-for="branch in reseller.branches")
                    td {{branch.businessName}}
                    td {{branch.address}}
                    td {{branch.businessType}}
                tr( v-if="!reseller.branches" )
                    td 
      .row
        .col.s12.m6.input-field
          div.card
            div.card-image
              img.upDTIimg(v-if="!pdocs[0]" src="/src/assets/img/no-image.jpg")

              img.upDTIimg(v-if="pdocs[0]" v-bind:src="pdocs[0].dti")  
              //- span.card-title DTI
            div.card-content
              label DTI
        .col.s12.m6.input-field
          div.card
            div.card-image
              img.upDTIimg(v-if="!pdocs[1]" src="/src/assets/img/no-image.jpg")
              //- h3 NO image
              img.upDTIimg(v-if="pdocs[1]" v-bind:src="pdocs[1].img2303")
              //- span.card-title 2303
            div.card-content
              label 2303


</template>
<script>
export default {
  props: ['reseller', 'pdocs'],
  computed: {
  }
}
</script>




// WEBPACK FOOTER //
// src/components/app-officer-details.vue